import Script from 'next/script';
import { FC } from 'react';
import site from 'pro/config/site';
import { getStoreState } from 'base/store';
import { isPhone } from 'base/utils/client';

declare const window: any;

const env = process.env.NEXT_PUBLIC_ENV_NAME === 'prod'
    ? 'prod'
    : 'test';

export const SnowplowInstaller: React.FC = () => {
    return !site.sp ? null : (
        <Script
            id="sp-sdk"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[]; p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments) };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1; n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","${site.sp.sdkUrl}","snowplow"));
snowplow("newTracker","${site.sp.projectName}","${site.sp.collector}",{appId:"${site.sp.appId[env]}",platform:"${isPhone ? 'mob' : 'pc'}",discoverRootDomain:true,cookieSameSite:"Lax",encodeBase64:true,sessionCookieTimeout:3600*3,contexts:{performanceTiming:true}, postPath:"${site.sp.postPath}"});`,
            }}
        />
    );
};

export const GaInstaller: FC = () => {
    const { country } = getStoreState('rootStore');
    const consentValue = country === 'DE' || country === 'GB' ? 'denied' : 'granted';

    return !site.ga ? null : (
        <>
            <Script
                id="ga-consent"
                strategy="beforeInteractive"
                dangerouslySetInnerHTML={{
                    __html: `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('consent', 'default', {
    'functionality_storage': '${consentValue}',
    'security_storage': '${consentValue}',
    'analytics_storage': '${consentValue}',
    'personalization_storage': '${consentValue}',
    'ad_storage': '${consentValue}',
    'ad_user_data': '${consentValue}',
    'ad_personalization': '${consentValue}',
});
`
                }}
            />

            <Script
                id="ga-sdk"
                strategy="afterInteractive"
                src={`${site.ga.sdkUrl}?id=${site.ga.trackingId}`}
                onLoad={() => {
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = function() {
                        window.dataLayer.push(arguments);
                    }
                    window.gtag('js', new Date());
                    window.gtag('config', '${site.ga.trackingId}');
                }}
            />
        </>
    )
};

// Facebook Pixel Code
/*export const facebookPixelInstaller = (
    <Script
        id="fb-sdk"
        dangerouslySetInnerHTML={{
            __html: `!function(f,b,e,v,n,t,s){if(f.fbq){return}n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq){f._fbq=n}n.push=n;n.loaded=!0;n.version="2.0";n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js");`,
        }}
    />
);*/

// GTM
export const GtmInstaller: FC = () => !site.gtm ? null : (
    <Script
        id="gtm-sdk"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='${site.gtm.sdkUrl}?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','gtmDataLayer','${site.gtm.containerId}');`,
        }}
    />
);